export default __webpack_public_path__ + "03c592caa772caa47ca5f5d3b139c252.png";